// components/Logo.js
import React from 'react';

const RFLogo = () => {
  return (
    <div className="flex items-center justify-center h-20">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="w-10 h-10 mr-1"
      >
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop
              offset="0%"
              style={{ stopColor: "#4f46e5", stopOpacity: 1 }}
            />
            <stop
              offset="100%"
              style={{ stopColor: "#6366f1", stopOpacity: 1 }}
            />
          </linearGradient>
        </defs>
        <path
          fill="url(#gradient)"
          d="M12 0L2 6v12l10 6 10-6V6L12 0zm0 3.553L18.698 7 12 10.447 5.302 7 12 3.553zM4 8.894l7 4.053v8.106l-7-4.053V8.894zm9 12.159v-8.106l7-4.053v8.106l-7 4.053z"
        />
        <path fill="#ffffff" d="M12 14a2 2 0 100-4 2 2 0 000 4z" />
        <path fill="#ffffff" d="M15.5 13.5l2-2M8.5 10.5l2-2M8.5 13.5l2 2" />
      </svg>
      <h1 className="text-xl font-extrabold text-gray-800 tracking-tight">
        RESUME
        <span className="text-indigo-600"> FLEX</span>
      </h1>
    </div>
  );
};

export default RFLogo;